module.exports = __webpack_public_path__ + "img/logo.14ad3120.png";